import { Button, GridItem } from "@chakra-ui/react";
import React from "react";
require("./Appointment.css");

interface AppointmentProps {
  time: string;
  onSlotPicked: any;
  isSelected: boolean;
  id?: string;
}

const Appointment = (props: AppointmentProps) => {
  const onSlotPicked = () => {
    props.onSlotPicked(props);
  };

  return (
    <Button
      as={GridItem}
      colorScheme="blue"
      background={props.isSelected ? "blue.300" : "transparent"}
      fontWeight="bold"
      w={"100%"}
      variant={props.isSelected ? "solid" : "outline"}
      onClick={onSlotPicked}
    >
      <p>{props.time}</p>
    </Button>
  );
};

export default Appointment;
